<template>
    <v-container fluid justify-center>
        <div class="pt-8 mt-6 not-found">
            <h1>404</h1>
            <h2>No content found</h2>
            <p>Please stick to the rivers and the lakes that you're used to.</p>
        </div>
    </v-container>  
</template>
    
<script>
export default {
    title: 'Darcey Grundy | Not Found',
    name: 'notFound',  
    data: () => ({
    }),
  }
</script>
    
<style lang="scss" scoped>
.not-found {
    display: flex;
    flex-direction: column;
    margin-right: auto;
    margin-left: auto;
    align-items: flex-start;
    width: 50%;

    h1, h2 {
        font-family: Bebas Neue;
        font-weight: 800;
        color: var(--v-tropicalIndigo-base) !important;
    }

    p {
        font-family: IBM Plex Sans;
        font-size: 18px;
        color: var(--v-tropicalIndigo-base) !important;
        padding: 0;
    }
}
</style>